<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-button type="success" @click="downloadFile">
        <img src="@/assets/images/icons/download.svg" alt="" style="margin-right: 5px" />
        Foydalanuvchilar listini yuklab olish
      </el-button>

      <el-upload
        :show-file-list="false"
        accept=".xlsx,.xls"
        :http-request="uploadFile"
      >
        <el-button type="warning">
          <img src="@/assets/images/icons/download.svg" alt="" style="margin-right: 5px; transform: rotate(180deg)" />
          Foydalanuvchilarni Excel orqali kiritish
        </el-button>
      </el-upload>

      <el-select
        v-model="selectedRegion"
        placeholder="Viloyatlar"
        @change="getRegions"
        :loading="regionsLoading"
        style="max-width: 320px"
      >
        <el-option value="" label="Barchasi" />
        <el-option
          v-for="region in regions"
          :key="region.id"
          :value="region.id"
          :label="region.title"
        />
      </el-select>

      <el-select v-model="status_filter" placeholder="Holat" clearable @change="getUsersList">
        <el-option label="Faol"       :value="1" />
        <el-option label="Nofaol"     :value="2" />
        <el-option label="Bloklangan" :value="3" />
        <el-option label="Jarayonda"  :value="4" />
      </el-select>

      <el-button type="primary" @click="$router.push({ name: 'MonitoringUserCreate' })">
        Qo'shish
      </el-button>
    </div>

    <el-table :data="users" border height="calc(100vh - 260px)">
      <el-table-column type="index" />
      <el-table-column prop="image_id" label="Rasm" width="90">
        <template v-slot="scope">
          <img
            :src="baseUrl + scope.row.image_id"
            v-if="scope.row.image_id"
            alt="user-img"
            class="user-img"
          />
          <img
            src="@/assets/images/user-avatar.png"
            v-else
            alt="user avatar"
            class="user-img"
          />
        </template>
      </el-table-column>
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="250" />
      <el-table-column prop="district_title" label="Tuman/Shahar" min-width="150" />
      <el-table-column prop="last_login_date" label="So'nggi kirish vaqti" min-width="150">
        <template v-slot="scope">
          {{ scope.row.last_login_date && $moment(scope.row.last_login_date).format("DD-MM-YYYY / HH:MM") }}
        </template>
      </el-table-column>
      <el-table-column prop="pinfl" label="Pinfl" min-width="150" />
      <el-table-column label="Holat" min-width="130">
        <template #default="scope">
          <el-tag :type="statusTagType(scope.row.status)" effect="light">
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="320" label="Amallar">
        <template #default="scope">
          <el-button size="small" @click="onEditUser(scope.row.id)" type="primary">Tahrirlash</el-button>
          <el-button size="small" @click="onDeleteUser(scope.row.id)" type="danger">O'chirish</el-button>
          <el-button
            v-if="$store.state.role === 'admin'"
            size="small"
            type="info"
            @click="showHistory(scope.row.id)"
          >Holat tarixi</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="historyDialog" title="Holat tarixi" width="800px">
      <div v-loading="historyLoading">
        <el-table :data="historyData" border size="small">
          <el-table-column label="Sana" min-width="140">
            <template #default="scope">{{ $moment(scope.row.changed_at).format("DD-MM-YYYY HH:mm") }}</template>
          </el-table-column>
          <el-table-column label="Oldingi holat" min-width="120">
            <template #default="scope">
              <el-tag :type="statusTagType(scope.row.old_status)" size="small" effect="light">{{ statusLabel(scope.row.old_status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Yangi holat" min-width="120">
            <template #default="scope">
              <el-tag :type="statusTagType(scope.row.new_status)" size="small" effect="light">{{ statusLabel(scope.row.new_status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="changed_by_fullname" label="Kim o'zgartirdi" min-width="160" />
          <el-table-column prop="reason" label="Sabab" min-width="160" />
        </el-table>
      </div>
    </el-dialog>

    <div class="pagination">
      <div>Foydalanuvchilar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "MonitoringUsersList",
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      loading: false,
      regionsLoading: false,
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      regions: [],
      selectedRegion: null,
      status_filter: null,
      users: [],
      historyDialog: false,
      historyLoading: false,
      historyData: [],
    };
  },
  methods: {
    showHistory(id) {
      this.historyData = [];
      this.historyDialog = true;
      this.historyLoading = true;
      this.$http.get(`/api/v1/managers/${id}`)
        .then(({ data }) => { this.historyData = data.status_history || []; })
        .catch(() => {})
        .finally(() => { this.historyLoading = false; });
    },
    statusLabel(status) {
      const map = { 1: "Faol", 2: "Nofaol", 3: "Bloklangan", 4: "Jarayonda" };
      return map[status] || "-";
    },
    statusTagType(status) {
      const map = { 1: "success", 2: "danger", 3: "danger", 4: "warning" };
      return map[status] || "info";
    },
    uploadFile({ file }) {
      const formData = new FormData();
      formData.append("file", file);
      this.loading = true;
      this.$http
        .post("api/v1/monitoring-users/sync-excel", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          ElNotification({ title: "Muvaffaqiyat", message: "Fayl muvaffaqiyatli yuklandi", type: "success" });
          this.getUsersList();
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Xatolik",
            message: response?.data?.message || "Fayl yuklashda xatolik sodir bo'ldi!",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadFile() {
      this.loading = true;
      this.$http
        .get("api/v1/monitoring-users/excel", { responseType: "blob" })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEditUser(id) {
      this.$router.push({ name: "MonitoringUserEdit", params: { id } });
    },
    onDeleteUser(id) {
      ElMessageBox.confirm("Foydalanuvchini o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/managers/${id}`)
            .then(() => {
              ElMessage({ type: "success", message: "Foydalanuvchi o'chirildi" });
              this.getUsersList();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({ type: "info", message: "O'chirish bekor qilindi" });
        });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
          this.getUsersList();
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getUsersList() {
      this.loading = true;
      this.$http
        .get("/api/v1/managers", {
          params: {
            role: "monitoring",
            region_id: this.selectedRegion,
            status: this.status_filter,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.users = data.users;
          this.totalCount = data.count;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange() {
      this.$router.replace({ query: { ...this.$route.query, page: this.currentPage } });
      this.getUsersList();
    },
    handleSizeChange() {
      this.$router.replace({ query: { ...this.$route.query, size: this.limit, page: 1 } });
      this.currentPage = 1;
      this.getUsersList();
    },
  },
  mounted() {
    if (this.$route.query.size) this.limit = parseInt(this.$route.query.size);
    if (this.$route.query.page) this.currentPage = parseInt(this.$route.query.page);
    this.getRegions();
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.user-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
